import React, { Component } from 'react';
export const dealersData = [{
  id: 'abe-irrigation',
  name: "ABE'S IRRIGATION",
  legalName: "ABE'S IRRIGATION LLC",
  country: 'United States',
  region: 'Aisco AMERICA',
  city: 'Texas',
  status: 'active',
  totalQuotes: 32,
  activeQuotes: 18,
  pendingQuotes: 8,
  approvedQuotes: 10,
  rejectedQuotes: 5,
  expiredQuotes: 9,
  totalRevenue: 387500,
  customers: 14,
  activeCustomers: 12,
  quotesTrend: 15,
  revenueTrend: 22,
  conversionRate: 68,
  conversionTrend: 5,
  avgQuoteValue: 12500,
  targetQuoteValue: 15000,
  avgValueTrend: 8,
  avgResponseTime: 12,
  responseTrend: -15,
  quotesHistory: [5, 8, 10, 12, 15, 18],
  avgCustomerSpend: 12450,
  recentActivity: [{
    type: 'quote',
    description: 'New quote #HX6AA6-3 created for $45,680',
    date: 'Jul 15, 2023',
    user: 'John Smith'
  }, {
    type: 'customer',
    description: 'New customer "Green Valley Farms" added',
    date: 'Jul 12, 2023',
    user: 'Maria Rodriguez'
  }, {
    type: 'quote',
    description: 'Quote #DKEYFH-1 approved for $64,699',
    date: 'Jul 10, 2023',
    user: 'John Smith'
  }, {
    type: 'quote',
    description: 'Quote #8X1VEC-3 updated with new specifications',
    date: 'Jul 5, 2023',
    user: 'Maria Rodriguez'
  }, {
    type: 'dealer',
    description: 'Account information updated',
    date: 'Jun 28, 2023',
    user: 'Admin'
  }, {
    type: 'quote',
    description: 'Quote #ZAK096-2 expired',
    date: 'Jun 25, 2023',
    user: 'System'
  }],
  alerts: [{
    severity: 'high',
    message: '3 quotes expiring in the next 7 days',
    date: 'Today'
  }, {
    severity: 'medium',
    message: 'Customer "Riverside Farms" has not placed an order in 90 days',
    date: 'Yesterday'
  }],
  recentQuotes: [{
    id: 'HX6AA6-3',
    date: 'Jul 15, 2023',
    product: 'Pivot Machine 8" 5/8 GALV',
    amount: 45680,
    status: 'pending'
  }, {
    id: 'DKEYFH-1',
    date: 'Jul 10, 2023',
    product: 'Reeltown 1058 ft wiper',
    amount: 64699,
    status: 'approved'
  }, {
    id: '8X1VEC-3',
    date: 'Jul 5, 2023',
    product: 'Linear Machine',
    amount: 76716,
    status: 'pending'
  }, {
    id: '1BGC13',
    date: 'Jun 28, 2023',
    product: 'Corner Arm',
    amount: 38207,
    status: 'approved'
  }, {
    id: 'MULEVO',
    date: 'Jun 20, 2023',
    product: 'High Profile',
    amount: 37174,
    status: 'rejected'
  }],
  customersList: [{
    name: 'Green Valley Farms',
    location: 'Austin, TX',
    email: 'contact@greenvalley.com',
    phone: '(512) 555-1234',
    quotes: 8,
    activeQuotes: 5,
    totalSpent: 98500,
    lastQuoteDate: 'Jul 15, 2023',
    lastQuoteProduct: 'Pivot Machine 8" 5/8 GALV'
  }, {
    name: 'Riverside Agriculture',
    location: 'Dallas, TX',
    email: 'info@riversideag.com',
    phone: '(214) 555-6789',
    quotes: 6,
    activeQuotes: 3,
    totalSpent: 75200,
    lastQuoteDate: 'Jul 8, 2023',
    lastQuoteProduct: 'Linear Machine'
  }, {
    name: 'Sunbelt Crops',
    location: 'Houston, TX',
    email: 'orders@sunbeltcrops.com',
    phone: '(713) 555-4321',
    quotes: 5,
    activeQuotes: 2,
    totalSpent: 68300,
    lastQuoteDate: 'Jun 30, 2023',
    lastQuoteProduct: 'Corner Arm'
  }, {
    name: 'Texas Harvest Co.',
    location: 'San Antonio, TX',
    email: 'sales@texasharvest.com',
    phone: '(210) 555-8765',
    quotes: 7,
    activeQuotes: 4,
    totalSpent: 82100,
    lastQuoteDate: 'Jun 22, 2023',
    lastQuoteProduct: 'High Profile'
  }, {
    name: 'Lone Star Farming',
    location: 'Fort Worth, TX',
    email: 'contact@lonestarfarm.com',
    phone: '(817) 555-2345',
    quotes: 4,
    activeQuotes: 2,
    totalSpent: 45800,
    lastQuoteDate: 'Jun 15, 2023',
    lastQuoteProduct: 'Pivot Package'
  }, {
    name: 'Hill Country Growers',
    location: 'Austin, TX',
    email: 'info@hillcountrygrowers.com',
    phone: '(512) 555-7890',
    quotes: 2,
    activeQuotes: 1,
    totalSpent: 17600,
    lastQuoteDate: 'Jun 10, 2023',
    lastQuoteProduct: 'Sprinkler System'
  }],
  notes: [{
    content: 'Dealer has shown interest in expanding their product line to include more drip irrigation solutions.',
    author: 'Maria Rodriguez',
    date: 'Jul 8, 2023'
  }, {
    content: 'Annual review meeting scheduled for August 15th.',
    author: 'John Smith',
    date: 'Jun 25, 2023'
  }],
  documents: [{
    name: 'Dealer Agreement.pdf',
    uploadDate: 'Jan 15, 2023',
    size: '2.4 MB'
  }, {
    name: 'Product Catalog 2023.pdf',
    uploadDate: 'Feb 3, 2023',
    size: '8.7 MB'
  }, {
    name: 'Training Certificate.pdf',
    uploadDate: 'Mar 22, 2023',
    size: '1.2 MB'
  }]
}, {
  id: 'adams-mobile',
  name: 'Adams Mobile Welding LLC',
  country: 'United States',
  region: 'Aisco AMERICA',
  city: 'California',
  totalQuotes: 28,
  activeQuotes: 15,
  pendingQuotes: 7,
  approvedQuotes: 8,
  rejectedQuotes: 4,
  expiredQuotes: 9,
  totalRevenue: 325000,
  customers: 12,
  quotesTrend: 8,
  revenueTrend: 12,
  quotesHistory: [4, 6, 9, 12, 14, 15]
}, {
  id: 'addison-irrigation',
  name: 'ADDISON IRRIGATION',
  country: 'United States',
  region: 'Aisco AMERICA',
  city: 'Georgia',
  totalQuotes: 22,
  activeQuotes: 12,
  pendingQuotes: 5,
  approvedQuotes: 7,
  rejectedQuotes: 3,
  expiredQuotes: 7,
  totalRevenue: 267500,
  customers: 10,
  quotesTrend: 5,
  revenueTrend: 8,
  quotesHistory: [3, 5, 8, 10, 12, 14]
}, {
  id: 'agri-market',
  name: 'AGRI MARKET BG',
  country: 'Bulgaria',
  region: 'Aisco EUROPE',
  city: 'Sofia',
  totalQuotes: 18,
  activeQuotes: 10,
  pendingQuotes: 4,
  approvedQuotes: 6,
  rejectedQuotes: 2,
  expiredQuotes: 6,
  totalRevenue: 210000,
  customers: 8,
  quotesTrend: 10,
  revenueTrend: 15,
  quotesHistory: [2, 4, 6, 8, 10, 12]
}, {
  id: 'agricultural-services',
  name: 'AGRICULTURAL SERVICES Inc.',
  country: 'United States',
  region: 'Aisco AMERICA',
  city: 'Iowa',
  totalQuotes: 35,
  activeQuotes: 20,
  pendingQuotes: 9,
  approvedQuotes: 11,
  rejectedQuotes: 6,
  expiredQuotes: 9,
  totalRevenue: 420000,
  customers: 16,
  quotesTrend: 18,
  revenueTrend: 25,
  quotesHistory: [6, 9, 12, 15, 18, 20]
}, {
  id: 'agritec-sa',
  name: 'AGRITEC S.A.',
  country: 'Nicaragua',
  region: 'Aisco AMERICA',
  city: 'Managua',
  totalQuotes: 15,
  activeQuotes: 8,
  pendingQuotes: 3,
  approvedQuotes: 5,
  rejectedQuotes: 2,
  expiredQuotes: 5,
  totalRevenue: 175000,
  customers: 7,
  quotesTrend: 12,
  revenueTrend: 18,
  quotesHistory: [1, 3, 5, 7, 9, 10]
}, {
  id: 'agro-supply',
  name: 'Agro supply',
  country: 'Mexico',
  region: 'Aisco AMERICA',
  city: 'Mexico City',
  totalQuotes: 20,
  activeQuotes: 11,
  pendingQuotes: 5,
  approvedQuotes: 6,
  rejectedQuotes: 3,
  expiredQuotes: 6,
  totalRevenue: 240000,
  customers: 9,
  quotesTrend: 15,
  revenueTrend: 20,
  quotesHistory: [3, 5, 8, 10, 12, 14]
}, {
  id: 'agro-venezolana',
  name: 'AGRO VENEZOLANA C.A.',
  country: 'Venezuela',
  region: 'Aisco LATAM',
  city: 'Caracas',
  totalQuotes: 12,
  activeQuotes: 6,
  pendingQuotes: 3,
  approvedQuotes: 3,
  rejectedQuotes: 2,
  expiredQuotes: 4,
  totalRevenue: 145000,
  customers: 5,
  quotesTrend: -5,
  revenueTrend: -8,
  quotesHistory: [4, 5, 6, 5, 4, 3]
}, {
  id: 'agro-plus',
  name: 'AGRO+ SRL',
  country: 'Italy',
  region: 'Aisco EUROPE',
  city: 'Rome',
  totalQuotes: 25,
  activeQuotes: 14,
  pendingQuotes: 6,
  approvedQuotes: 8,
  rejectedQuotes: 4,
  expiredQuotes: 7,
  totalRevenue: 295000,
  customers: 11,
  quotesTrend: 20,
  revenueTrend: 28,
  quotesHistory: [2, 5, 8, 12, 16, 20]
}, {
  id: 'agroccesorios',
  name: 'Agroccesorios Hidraulicos',
  country: 'Mexico',
  region: 'Aisco AMERICA',
  city: 'Guadalajara',
  totalQuotes: 17,
  activeQuotes: 9,
  pendingQuotes: 4,
  approvedQuotes: 5,
  rejectedQuotes: 3,
  expiredQuotes: 5,
  totalRevenue: 205000,
  customers: 8,
  quotesTrend: 10,
  revenueTrend: 15,
  quotesHistory: [2, 4, 6, 8, 10, 12]
}, {
  id: 'agromak',
  name: 'AGROMAK',
  country: 'Mexico',
  region: 'Aisco AMERICA',
  city: 'Monterrey',
  totalQuotes: 19,
  activeQuotes: 10,
  pendingQuotes: 5,
  approvedQuotes: 5,
  rejectedQuotes: 3,
  expiredQuotes: 6,
  totalRevenue: 230000,
  customers: 9,
  quotesTrend: 8,
  revenueTrend: 12,
  quotesHistory: [3, 5, 7, 9, 11, 13]
}, {
  id: 'agroseeds',
  name: 'AGROSEEDS LLC',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/98cPYqokeqZwHPM3SdEb13/image.png',
  country: 'Azerbaijan',
  region: 'Aisco EUROPE',
  city: 'Baku',
  state: '',
  postalCode: 'AZ1072',
  address: 'N. Narimanovsky district, Str. Ashig Ali, House 3, #',
  email: 'info@agroseeds.az',
  phone: '+994 12 555 1234',
  website: 'https://agroseeds.az',
  primaryContact: 'Eldar Mammadov',
  taxId: '1505617181',
  businessType: 'Limited Liability Company',
  yearEstablished: '2015',
  status: 'active',
  accountType: 'Premium',
  accountManager: 'Olexandr Morozov',
  customerSince: 'January 2018',
  paymentTerms: 'Net 30',
  creditLimit: 50000,
  currency: 'USD',
  totalQuotes: 42,
  activeQuotes: 23,
  pendingQuotes: 10,
  approvedQuotes: 13,
  rejectedQuotes: 7,
  expiredQuotes: 12,
  totalRevenue: 515000,
  customers: 18,
  activeCustomers: 15,
  quotesTrend: 25,
  revenueTrend: 32,
  conversionRate: 72,
  conversionTrend: 8,
  avgQuoteValue: 14500,
  targetQuoteValue: 18000,
  avgValueTrend: 12,
  avgResponseTime: 8,
  responseTrend: -20,
  quotesHistory: [8, 12, 16, 20, 24, 28],
  avgCustomerSpend: 15750,
  recentActivity: [{
    type: 'quote',
    description: 'New quote #AG2023-42 created for $68,350',
    date: 'Jul 14, 2023',
    user: 'Eldar Mammadov'
  }, {
    type: 'customer',
    description: 'New customer "Azerbaijan Farms Ltd." added',
    date: 'Jul 10, 2023',
    user: 'Leyla Aliyeva'
  }, {
    type: 'quote',
    description: 'Quote #AG2023-38 approved for $92,475',
    date: 'Jul 8, 2023',
    user: 'Eldar Mammadov'
  }, {
    type: 'quote',
    description: 'Quote #AG2023-35 updated with new specifications',
    date: 'Jul 3, 2023',
    user: 'Leyla Aliyeva'
  }, {
    type: 'dealer',
    description: 'Account information updated',
    date: 'Jun 25, 2023',
    user: 'Admin'
  }, {
    type: 'quote',
    description: 'Quote #AG2023-30 expired',
    date: 'Jun 20, 2023',
    user: 'System'
  }],
  alerts: [{
    severity: 'high',
    message: '4 quotes expiring in the next 7 days',
    date: 'Today'
  }, {
    severity: 'medium',
    message: 'Customer "Caspian Agricultural" has not placed an order in 60 days',
    date: 'Yesterday'
  }, {
    severity: 'low',
    message: 'New product catalog available for distribution',
    date: '3 days ago'
  }],
  recentQuotes: [{
    id: 'AG2023-42',
    date: 'Jul 14, 2023',
    product: 'Center Pivot Irrigation System',
    amount: 68350,
    status: 'pending'
  }, {
    id: 'AG2023-38',
    date: 'Jul 8, 2023',
    product: 'Complete Farm Irrigation Solution',
    amount: 92475,
    status: 'approved'
  }, {
    id: 'AG2023-35',
    date: 'Jul 3, 2023',
    product: 'Linear Irrigation System',
    amount: 78500,
    status: 'pending'
  }, {
    id: 'AG2023-32',
    date: 'Jun 28, 2023',
    product: 'Drip Irrigation System',
    amount: 45200,
    status: 'approved'
  }, {
    id: 'AG2023-30',
    date: 'Jun 20, 2023',
    product: 'Sprinkler Irrigation Package',
    amount: 38750,
    status: 'expired'
  }],
  customersList: [{
    name: 'Azerbaijan Farms Ltd.',
    location: 'Baku, AZ',
    email: 'contact@azfarms.az',
    phone: '+994 12 555 6789',
    quotes: 10,
    activeQuotes: 6,
    totalSpent: 125000,
    lastQuoteDate: 'Jul 14, 2023',
    lastQuoteProduct: 'Center Pivot Irrigation System'
  }, {
    name: 'Caspian Agricultural',
    location: 'Sumgait, AZ',
    email: 'info@caspianag.az',
    phone: '+994 18 555 1234',
    quotes: 8,
    activeQuotes: 4,
    totalSpent: 98000,
    lastQuoteDate: 'May 18, 2023',
    lastQuoteProduct: 'Drip Irrigation System'
  }, {
    name: 'Caucasus Growers',
    location: 'Ganja, AZ',
    email: 'orders@caucasusgrowers.az',
    phone: '+994 22 555 7890',
    quotes: 7,
    activeQuotes: 3,
    totalSpent: 85000,
    lastQuoteDate: 'Jul 5, 2023',
    lastQuoteProduct: 'Linear Irrigation System'
  }, {
    name: 'Baku Agro Industries',
    location: 'Baku, AZ',
    email: 'sales@bakuagro.az',
    phone: '+994 12 555 4321',
    quotes: 9,
    activeQuotes: 5,
    totalSpent: 110000,
    lastQuoteDate: 'Jun 30, 2023',
    lastQuoteProduct: 'Complete Farm Irrigation Solution'
  }, {
    name: 'Araz Valley Farms',
    location: 'Lankaran, AZ',
    email: 'contact@arazvalley.az',
    phone: '+994 25 555 6543',
    quotes: 6,
    activeQuotes: 3,
    totalSpent: 72000,
    lastQuoteDate: 'Jun 25, 2023',
    lastQuoteProduct: 'Sprinkler Irrigation Package'
  }, {
    name: 'Silk Road Agriculture',
    location: 'Shaki, AZ',
    email: 'info@silkroadag.az',
    phone: '+994 24 555 3456',
    quotes: 5,
    activeQuotes: 2,
    totalSpent: 60000,
    lastQuoteDate: 'Jun 18, 2023',
    lastQuoteProduct: 'Drip Irrigation System'
  }, {
    name: 'Green Azerbaijan',
    location: 'Baku, AZ',
    email: 'sales@greenaz.az',
    phone: '+994 12 555 8765',
    quotes: 4,
    activeQuotes: 2,
    totalSpent: 48000,
    lastQuoteDate: 'Jun 12, 2023',
    lastQuoteProduct: 'Sprinkler System Components'
  }, {
    name: 'Absheron Agricultural Cooperative',
    location: 'Khirdalan, AZ',
    email: 'coop@absheronag.az',
    phone: '+994 12 555 2345',
    quotes: 3,
    activeQuotes: 1,
    totalSpent: 35000,
    lastQuoteDate: 'Jun 5, 2023',
    lastQuoteProduct: 'Small Farm Irrigation Kit'
  }],
  notes: [{
    content: 'AGROSEEDS LLC is planning to expand their operations to include more fruit orchards in the southern regions. They are interested in specialized irrigation solutions for these new areas.',
    author: 'Olexandr Morozov',
    date: 'Jul 12, 2023'
  }, {
    content: 'Annual business review meeting scheduled for September 5th. Will discuss new product offerings and potential expansion opportunities.',
    author: 'Leyla Aliyeva',
    date: 'Jul 1, 2023'
  }, {
    content: 'Customer expressed interest in training sessions for their technical staff on maintenance of irrigation systems.',
    author: 'Eldar Mammadov',
    date: 'Jun 15, 2023'
  }],
  documents: [{
    name: 'AGROSEEDS Dealer Agreement 2023.pdf',
    uploadDate: 'Jan 10, 2023',
    size: '3.2 MB'
  }, {
    name: 'Technical Training Certificate.pdf',
    uploadDate: 'Mar 15, 2023',
    size: '1.8 MB'
  }, {
    name: 'Product Catalog - Azerbaijan Edition.pdf',
    uploadDate: 'Feb 8, 2023',
    size: '12.5 MB'
  }, {
    name: 'Credit Application Form.pdf',
    uploadDate: 'Jan 5, 2023',
    size: '0.8 MB'
  }]
}];